unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.ComCtrls,
  strutils, Vcl.StdCtrls, WEBLib.StdCtrls, dateutils,
  WEBLib.Login, Data.DB, weblib.json, WEBLib.Storage,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons,
  WEBLib.DB, WEBLib.WebCtrls, WEBLib.DBCtrls, WEBLib.REST, XData.Web.Client,
  XData.Web.Connection, Vcl.Menus, WEBLib.Menus, weblib.RegularExpressions;


type
  TForm1 = class(TForm)
    XDPersonal: TXDataWebDataSet;
    XDPersonalPersonalnummer: TIntegerField;
    XDPersonalNachname: TStringField;
    XDPersonalVorname: TStringField;
    XDPersonalSchreibzeichen: TStringField;
    XDPersonalLoginName: TStringField;
    XDPersonalPassword: TStringField;
    XDPersonalEnabled: TBooleanField;
    XDPersonalEmail: TStringField;
    XDPersonalFarbe: TIntegerField;
    lblAnmeldung: TLabel;
    WebPanelMenue: TPanel;
    panelAnmeldung: TPanel;
    WebLabel3: TLabel;
    edtBenutzer: TEdit;
    edtPassword: TEdit;
    btnAnmelden: TButton;
    labelonlinestatus: TLabel;
    WebDBLabel1: TDBLabel;
    XDPersonalPersonalGUID: TStringField;
    WebHttpRequest1: THttpRequest;
    WClient: TXDataWebClient;
    AuthConnection: TXDataWebConnection;
    XDPersonalRechteCadiaWEB: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    lblchecklogin: TLabel;
    btnLogout: TButton;
    btnTermine: TButton;
    btnEmails: TButton;
    btnAnrufe: TButton;
    btnPZE: TButton;
    btnTelefonnummern: TButton;
    XDPersonalStundensatzIntern: TFloatField;
    btnMitteilungen: TButton;
    xdsMitteilungen: TXDataWebDataSet;
    xdsMitteilungenMSGBoardID: TXDataWebEntityField;
    xdsMitteilungenToPersonalnummer: TXDataWebEntityField;
    xdsMitteilungenMSGBoardSubID: TStringField;
    xdsMitteilungenToNachname: TStringField;
    xdsMitteilungenToVorname: TStringField;
    xdsMitteilungenDatumGelesen: TDateTimeField;
    xdsMitteilungenDatumErledigt: TDateTimeField;
    xdsMitteilungenMSGBoardIDFromPersonalnummer: TXDataWebEntityField;
    xdsMitteilungenMSGBoardIDID: TStringField;
    xdsMitteilungenMSGBoardIDDatum: TDateTimeField;
    xdsMitteilungenMSGBoardIDFromNachname: TStringField;
    xdsMitteilungenMSGBoardIDFromVorname: TStringField;
    xdsMitteilungenMSGBoardIDBetreff: TStringField;
    xdsMitteilungenMSGBoardIDNotiz: TStringField;
    xdsMitteilungenToPersonalnummerPersonalnummer: TIntegerField;
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer: TIntegerField;
    btnTickets: TButton;
    btnBeenden: TButton;
    Menue10055: TPanel;
    btnLogbuch: TButton;
    btnZurueck: TButton;
    btnKontakte: TButton;
    btnArtikel: TButton;
    btnBestellvormerkung: TButton;
    btnAngebote: TButton;
    btnAuftrag: TButton;
    btnLieferscheine: TButton;
    btnBelegePositionen: TButton;
    btnInventur: TButton;
    btn14584: TButton;
    Container3: THTMLContainer;
    CheckPasswortMerken: TCheckBox;
    procedure setcontrols;
    procedure XDPersonalAfterOpen(DataSet: TDataSet);
    procedure btnLogoutClick(Sender: TObject);
    procedure btnTermineClick(Sender: TObject);
    procedure btnArtikelClick(Sender: TObject);
    procedure btnAnrufeClick(Sender: TObject);
    procedure btnKontakteClick(Sender: TObject);
    procedure btnAuftragClick(Sender: TObject);
    procedure btnAnmeldenClick(Sender: TObject);
    procedure edtBenutzerKeyPress(Sender: TObject; var Key: Char);
    procedure edtPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure AuthConnectionConnect(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnAngeboteClick(Sender: TObject);
    procedure btnPZEClick(Sender: TObject);
    procedure btnEmailsClick(Sender: TObject);
    procedure btnBelegePositionenClick(Sender: TObject);
    procedure btnLieferscheineClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormBeforeUnload(Sender: TObject; var AMessage: string);
    procedure btnBestellvormerkungClick(Sender: TObject);
    procedure btnTelefonnummernClick(Sender: TObject);
    procedure btnMitteilungenClick(Sender: TObject);
    procedure xdsMitteilungenAfterOpen(DataSet: TDataSet);
    procedure btnTicketsClick(Sender: TObject);
    procedure btnBeendenClick(Sender: TObject);
    procedure btn14584Click(Sender: TObject);
    procedure btnZurueckClick(Sender: TObject);
    procedure btnLogbuchClick(Sender: TObject);
    procedure btnInventurClick(Sender: TObject);



  public
    type
      TRechteCadiaWebR = Record
        Zugelassen:boolean;
        Kontakte:boolean;
        Artikel:boolean;
        OffeneAngebote:boolean;
        OffeneAuftraege:boolean;
        OffeneLieferscheine:boolean;
        Termine:boolean;
        NurPersTermine:boolean;
        Emails:boolean;
        BelegePositionen:boolean;
        Anrufe:boolean;
        Zeiterfassung:boolean;
        Einkaufspreise:boolean;
        Verkaufspreise:boolean;
        Mitteilungen:boolean;
        Inventur:boolean;
    End;
    var RCW:TRechteCadiaWebR;
    var RCWLIST:TStringList;
    webverlassen:string;
    webverlassennichtfragen:boolean;
    procedure RCWLISTtoRECORD;
    procedure RCWleeren;
    procedure AppOnlineChange(Sender:TObject; AStatus: TOnlineStatus);
    procedure Tokenholen(Username, Password: string);
    function XorStr(const Text: string; Key: Integer): string;
    procedure KalkuliereMitteilungen;
    function ValidateEmail(const emailAddress: string): Boolean;
    function StripSonderzeichen(alterstring:string):string;
  protected procedure LoadDFMValues; override; end;

const
  Versionslabel1='©2026 Cadia Software GmbH Version ';
  Versionslabel2='3.4.3';
  Versionslabel3='15.05.2026';
  Versionslabel4=' <a href="https://www.cadia.de" target="_blank">(cadia-Webseite)</a>';
  CadiaAppKey='991783241';
  CadiaAppKeyServerLizenz='123458420';
var
  Form1: TForm1;
  Versionslabel:string;
  CadiaKundennummer:string;
  BenutzerAngemeldet:Boolean;
  BenutzerLoginName:string;
  BenutzerPasswort:string;
  BenutzerZugangSpeichern:string;
  BenutzerPersonalnummer:string;
  BenutzerNachname:string;
  BenutzerVorname:string;
  BenutzerSchreibzeichen:string;
  BenutzerEmail:string;
  BenutzerFarbe:integer;
  BenutzerID:string;
  BenutzerStundensatzIntern:double;
  TextAbsenderzeile:string;
  xdataDATASERVER:string;
  xdataconnectionstring:string;
  xdataauthconnection:string;
  downloadconnection:string;
  xdatausername:string;
  xdatapassword:string;
  Merkerkontaktnummer:string;
  MerkerArtikelnummer:string;
  LizenzOK:boolean;
  vtoken:string;
  ajahr, amonat, atag,astunde,aminute,asekunde,ams:word;
  scannereinstellung:string;
  PZE_AutoObjektnummer:string;
  PZE_AutoAuftragnummer:string;
  PZE_Objekt_erlaubt:integer;
  PZE_Auftrag_erlaubt:integer;

implementation
  uses unit2, unit_Kontaktsuche, unit_Artikelsuche, unit_Objektsuche, unit_Einzeltermin, unit_EinzelAuftrag, unit_Anrufe, unit_Artikel,
  unit_Terminkalender, unit_ListeAuftrag, unit_EinzelKontakt, unit_ListeAngebot, unit_PZE, unit_EmailEingang, unit_BelegeUndPositionen,
  unit_ListeLieferschein, unit_Bestellvormerkung, unit_TelefonSuche, unit_Mitteilungen, unit_ListeTickets, unit_GetPhoto, unit_Logbuch,
  unit_Inventur;
{$R *.dfm}

function TForm1.XorStr(const Text: string; Key: Integer): string;
var
  i: Integer;
begin
  SetLength(Result, Length(Text));
  for i:=1 to Length(Text) do
  begin
    if Text[i] > #31 then
      Result[i] := Chr(Ord(Text[i]) xor Key)
    else
      Result[i] := Text[i];
  end;
end;

function TForm1.ValidateEmail(const emailAddress: string): Boolean;
var
  RegEx: TRegEx;
begin
  RegEx := TRegex.Create('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]*[a-zA-Z0-9]+$');
  Result := RegEx.Match(emailAddress).Success;
end;

function TForm1.StripSonderzeichen(alterstring:string):string;
var
  neustring:string;
begin
  result:='';
  neustring:=trim(alterstring);
  neustring:=stringreplace(neustring,'.','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'\','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'/','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,':','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'*','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'*','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'"','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'~','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'<','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'>','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'|','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'{','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'}','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'[','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,']','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,' ','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'&','_',[rfreplaceall]);
  result:=neustring;
end;

procedure TForm1.KalkuliereMitteilungen;
begin
  btnMitteilungen.Caption:='Mitteilungen (-)';
  btnMitteilungen.ElementClassName:='btn btn-info btn-sm text-center';
  xdsMitteilungen.Close;
  xdsMitteilungen.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=(ToPersonalnummer eq '+Benutzerpersonalnummer+') AND (DatumErledigt eq null OR DatumGelesen eq null)&$orderby=MSGBoardID/Datum DESC';
  xdsMitteilungen.Load;
end;

procedure TForm1.AppOnlineChange(Sender:TObject; AStatus: TOnlineStatus);
begin
  if (Application.IsOnline) then labelonlinestatus.Caption:='online' else labelonlinestatus.Caption:='offline';
end;

procedure TForm1.Tokenholen(Username, Password: string);
  procedure OnResponse(Response:TXDataClientResponse);
  begin
    vtoken:=string(TJSObject(response.Result)['value']);
    if xdataconnectionstring<>'' then
    begin
      dm2.XDataWebConnection1.url:=xdataconnectionstring;
      dm2.xdatawebconnection1.Connected:=true;
    end;
  end;
begin
  labelonlinestatus.Caption:='hole token';
  WClient.RawInvoke('ILoginService.Login',[Username,Password],@OnResponse);
end;




procedure TForm1.AuthConnectionConnect(Sender: TObject);
begin
  Tokenholen(xdatausername,xdatapassword);
end;

procedure TForm1.btn14584Click(Sender: TObject);
begin
  //nur für 14584
  Menue10055.Visible:=true;
  Webpanelmenue.visible:=false;
end;

procedure TForm1.btnAngeboteClick(Sender: TObject);
var
  ListeAngebot:TListeAngebot;
begin
  webpanelmenue.Visible:=false;


  ListeAngebot := TListeAngebot.CreateNew(procedure(AForm: TObject)
    begin

    end
    );

  ListeAngebot.ShowModal(procedure(AValue: TModalResult)
    begin
      webpanelmenue.Visible:=true;
    end
    );
end;

procedure TForm1.btnAnmeldenClick(Sender: TObject);
begin
  lblchecklogin.Caption:='';
  if edtbenutzer.text='' then
  begin
    lblchecklogin.Caption:='Sie müssen Ihren Benutzernamen eingeben';
    edtbenutzer.SetFocus;
    exit;
  end;
  if edtPassword.text='' then
  begin
    lblchecklogin.Caption:='Sie müssen Ihr Passwort eingeben';
    edtpassword.SetFocus;
    exit;
  end;
  if edtbenutzer.text='superuser' then
  begin
    lblchecklogin.Caption:='Diesen Benutzer dürfen Sie im WebPortal nicht verwenden';
    edtbenutzer.SetFocus;
    exit;

  end;
  BenutzerLoginName:=edtbenutzer.text;
  BenutzerPasswort:=edtpassword.text;
  xdpersonal.Close;
  xdpersonal.QueryString:='$filter=LoginName eq '''+BenutzerLoginName+'''';
  XDPersonal.Load;
end;

procedure TForm1.btnAnrufeClick(Sender: TObject);
var
  newform:TfrmAnrufe;
begin
  newform := TfrmAnrufe.CreateNew;
end;

procedure TForm1.btnArtikelClick(Sender: TObject);
var
  LFrm:TfrmArtikelsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmArtikelsuche;
    begin
      LForm:=(AForm as TfrmArtikelsuche);
      lform.weiterzueinzelartikel:=true;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      webpanelmenue.Visible:=true;
    end;

  begin
  webpanelmenue.Visible:=false;
  LFrm:=TfrmArtikelsuche.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnAuftragClick(Sender: TObject);
var
  ListeAuftrag:TListeAuftrag;
begin
  webpanelmenue.Visible:=false;


ListeAuftrag := TListeAuftrag.CreateNew(procedure(AForm: TObject)
    begin

    end
    );

  ListeAuftrag.ShowModal(procedure(AValue: TModalResult)
    begin
      webpanelmenue.Visible:=true;
    end
    );


end;

procedure TForm1.btnBeendenClick(Sender: TObject);
begin
  webverlassennichtfragen:=true;
  window.close;
  try
    application.Navigate('https://cadia.de',ntPage);
  except

  end;

end;

procedure TForm1.btnBelegePositionenClick(Sender: TObject);
var
  LFrm:TBelegePositionen;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBelegePositionen;
    begin
      LForm:=(AForm as TBelegePositionen);
      LForm.BPKundennummer:='';
      LForm.BPName:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TBelegePositionen.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
end;

procedure TForm1.btnBestellvormerkungClick(Sender: TObject);
var
  LFrm:TBestellvormerkung;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TBestellvormerkung;
    begin
      LForm:=(AForm as TBestellvormerkung);
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      webpanelmenue.Visible:=true;
    end;

  begin
  webpanelmenue.Visible:=false;
  LFrm:=TBestellvormerkung.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnEmailsClick(Sender: TObject);
var
  newform:TEmailEingang;
begin
  newform := TEmailEingang.CreateNew;
end;

procedure TForm1.btnInventurClick(Sender: TObject);
var
  LFrm:TfrmInventur;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TfrmInventur;
    begin
      LForm:=(AForm as TfrmInventur);
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TfrmInventur.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
end;

procedure TForm1.btnKontakteClick(Sender: TObject);
var
  LFrm:TfrmKontaktsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktsuche;
    begin
      LForm:=(AForm as TfrmKontaktsuche);
      lform.weiterzuEinzelkontakt:=true;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      webpanelmenue.Visible:=true;
    end;

  begin
  webpanelmenue.Visible:=false;
  LFrm:=TfrmKontaktsuche.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);
end;

procedure TForm1.btnLieferscheineClick(Sender: TObject);
var
  newform:TListeLieferschein;
begin
  newform := TListeLieferschein.CreateNew;
end;

procedure TForm1.btnLogbuchClick(Sender: TObject);
var
  newform:TfrmLogbuch;
begin
  newform := TfrmLogbuch.CreateNew;

end;

procedure TForm1.btnLogoutClick(Sender: TObject);
begin
  btnlogout.Visible:=false;
  dm2.XDataWebConnection1.Connected:=false;
  lblchecklogin.Caption:='';
  BenutzerAngemeldet:=false;
  BenutzerLoginName:='';
  BenutzerPasswort:='';
  BenutzerPersonalnummer:='';
  BenutzerNachname:='';
  BenutzerVorname:='';
  BenutzerSchreibzeichen:='';
  BenutzerEmail:='';
  BenutzerStundensatzIntern:=0;
  SetControls;
end;

procedure TForm1.btnMitteilungenClick(Sender: TObject);
var
  LFrm:TMitteilungen;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TMitteilungen;
    begin
      LForm:=(AForm as TMitteilungen);
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      webpanelmenue.Visible:=true;
      KalkuliereMitteilungen;
    end;

  begin
  webpanelmenue.Visible:=false;
  LFrm:=TMitteilungen.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);
end;

procedure TForm1.btnPZEClick(Sender: TObject);
var
  newform:TPZE;
begin
  PZE_AutoObjektnummer:='';
  PZE_AutoAuftragnummer:='';
  newform := TPZE.CreateNew;
end;

procedure TForm1.btnTelefonnummernClick(Sender: TObject);
var
  LFrm:TfrmTelefonSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmTelefonSuche;
    begin
      LForm:=(AForm as TfrmTelefonSuche);
      lform.weiterzuEinzelkontakt:=true;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      webpanelmenue.Visible:=true;

    end;

  begin
  webpanelmenue.Visible:=false;
  LFrm:=TfrmTelefonSuche.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnTermineClick(Sender: TObject);
var
  Terminkalender:TTerminkalender;
begin
  webpanelmenue.Visible:=false;
  Terminkalender := TTerminkalender.CreateNew(procedure(AForm: TObject)
    begin
      window.location.hash := 'subform';
    end
    );

  Terminkalender.ShowModal(procedure(AValue: TModalResult)
    begin
      webpanelmenue.Visible:=true;
    end
    );
end;

procedure TForm1.btnTicketsClick(Sender: TObject);
var
  LFrm:TListeTickets;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TListeTickets;
    begin
      LForm:=(AForm as TListeTickets);

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TListeTickets.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnZurueckClick(Sender: TObject);
begin
  Menue10055.Visible:=false;
  Webpanelmenue.visible:=true;
end;

procedure TForm1.edtBenutzerKeyPress(Sender: TObject; var Key: Char);
begin
if key=#13 then edtPassword.SetFocus;

end;

procedure TForm1.edtPasswordKeyPress(Sender: TObject; var Key: Char);
begin
if key=#13 then btnAnmeldenClick(sender);

end;

procedure TForm1.setcontrols;
var
  mylocalstorage:TLocalStorage;
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h4>CadiaWEB</h4><small>'+Versionslabel+'</small></nav>';

  myelement:=Container1.ElementHandle;
  lblAnmeldung.ParentElement:=myelement;
  labelonlinestatus.ParentElement:=myelement;
  WebDBLabel1.ParentElement:=myelement;

  container2.ParentElement:=myelement;

  myelement:=container2.ElementHandle;
  panelanmeldung.ParentElement:=myelement;
  WebPanelMenue.ParentElement:=myelement;
  Menue10055.ParentElement:=myelement;

  myelement:=panelAnmeldung.ElementHandle;
  WebLabel3.ParentElement:=myelement;

  edtbenutzer.ParentElement:=myelement;
  edtPassword.ParentElement:=myelement;

  btnAnmelden.ParentElement:=myelement;
  lblchecklogin.parentelement:=myelement;

  container3.ParentElement:=myelement;
  myelement:=container3.ElementHandle;
  CheckPasswortMerken.ParentElement:=myelement;

  if BenutzerAngemeldet then
  begin
    btnLogout.Visible:=true;
    lblAnmeldung.Caption:='User: '+BenutzerPersonalnummer+' | '+BenutzerLoginName+' | '+BenutzerNachname+', '+BenutzerVorname;
    WebPanelMenue.Visible:=true;
    panelAnmeldung.Visible:=false;
    btnkontakte.enabled:=rcw.Kontakte;
    btnartikel.enabled:=rcw.Artikel;
    btnangebote.enabled:=rcw.OffeneAngebote;
    btnauftrag.enabled:=rcw.offeneAuftraege;
    btnlieferscheine.enabled:=rcw.offeneLieferscheine;
    btntermine.enabled:=rcw.termine;
    btnemails.enabled:=rcw.emails;
    btnbelegepositionen.enabled:=rcw.belegepositionen;
    btnAnrufe.enabled:=rcw.Anrufe;
    btnPZE.enabled:=rcw.Zeiterfassung;
    btnMitteilungen.Enabled:=RCW.Mitteilungen;
    btnInventur.Enabled:=RCW.Inventur;
    if CadiaKundennummer='14584' then
    begin
      btn14584.Visible:=true;
      btn14584.Enabled:=true;
    end;
  end
  else
  begin
    btn14584.Visible:=false;
    btn14584.Enabled:=false;
    btnLogout.Visible:=false;
    lblanmeldung.Caption:='Sie sind nicht angemeldet';
    WebPanelMenue.Visible:=false;
    panelanmeldung.Visible:=true;
    mylocalstorage:=TLocalStorage.Create;
    edtBenutzer.text:=mylocalstorage.GetValue('CadiaWEBBenutzer');
    BenutzerZugangSpeichern:=mylocalstorage.getvalue('BenutzerZugangSpeichern');
    if BenutzerZugangSpeichern='1' then
    begin
      CheckPasswortMerken.checked:=true;
    end
    else
    begin
      CheckPasswortMerken.checked:=false;
    end;
    if BenutzerZugangSpeichern='1' then
    begin
      edtPassword.text:=XorStr(mylocalstorage.GetValue('CadiaWEBPW'),25);
    end;

    scannereinstellung:=mylocalstorage.GetValue('CadiaWEBScanner');
    if scannereinstellung='' then scannereinstellung:='11111111111';
    mylocalstorage.Free;
    edtbenutzer.SetFocus;
    if edtbenutzer.Text<>'' then edtPassword.SetFocus;
  end;

end;

procedure TForm1.WebFormBeforeUnload(Sender: TObject; var AMessage: string);
begin
  if webverlassennichtfragen=false then AMessage:=webverlassen;
end;

procedure TForm1.WebFormCreate(Sender: TObject);
begin
  RCWLIST:=TStringList.Create;
  RCWLIST.NameValueSeparator:='|';
  PZE_Objekt_erlaubt:=0;
  PZE_Auftrag_erlaubt:=0;
  BenutzerZugangSpeichern:='0';
end;

procedure TForm1.WebFormShow(Sender: TObject);
begin
  CadiaKundennummer:='';
  btn14584.visible:=false;
  btn14584.Enabled:=false;
  btnAnmelden.Enabled:=false;
  application.OnOnlineChange:=AppOnlineChange;
  Versionslabel:=Versionslabel1+Versionslabel2+' vom '+Versionslabel3+Versionslabel4;
  webverlassennichtfragen:=false;
  webverlassen:='CadiaWEB verlassen?';
  lblchecklogin.Caption:='';
  BenutzerStundensatzIntern:=0;
  setcontrols;
  LizenzOK:=false;
  WebHttpRequest1.Execute;
end;

procedure TForm1.WebHttpRequest1Response(Sender: TObject; AResponse: string);
var
  RStringList:TStringList;
  s:string;
begin
  if aresponse='' then
  begin
    showmessage('Die Konfigurationsdatei ist nicht vorhanden oder fehlerhaft');
    exit;
  end;
  if aresponse<>'' then
  begin
    RStringList:=TStringList.Create;
    RStringList.Text:=aresponse;
    s:= XorStr(RStringList.Strings[0],25);
    xdataDATASERVER:=trim(ReplaceStr(s,'DATASERVER=',''));
    if RightStr(xdataDATASERVER,1)<>'/' then xdataDATASERVER:=xdataDATASERVER+'/';
    xdataconnectionstring:=xdataDATASERVER+'cadiaserver/xdata';
    downloadconnection:=xdataDATASERVER+'cadiaserver/filedownload?FileName=';
    xdataauthconnection:=xdataDATASERVER+'cadiaserverauth';
    s:= XorStr(RStringList.Strings[1],25);
    xdatausername:=trim(ReplaceStr(s,'USERNAME=',''));
    s:= XorStr(RStringList.Strings[2],25);
    xdatapassword:=trim(ReplaceStr(s,'PASSWORD=',''));
    AuthConnection.Connected:=false;
    AuthConnection.URL:=xdataauthconnection;
    authconnection.Connected:=true;
  end;
end;

procedure TForm1.XDPersonalAfterOpen(DataSet: TDataSet);
var
  mylocalstorage:TLocalStorage;
  logbuchurl:string;
begin
  if xdpersonal.RecordCount<1 then
  begin
    lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';
    xdpersonal.Close;
    exit;
  end;
  xdpersonal.First;

    if (XDPersonalPassword.AsString=BenutzerPasswort) AND (XDPersonalLoginName.AsString=BenutzerLoginName) then
    begin
      if XDPersonalEnabled.AsBoolean=true then
      begin
        BenutzerAngemeldet:=true;
        BenutzerPersonalnummer:=XDPersonalPersonalnummer.AsString;
        BenutzerLoginName:=XDPersonalLoginName.AsString;
        BenutzerNachname:=XDPersonalNachname.AsString;
        BenutzerVorname:=XDPersonalVorname.AsString;
        BenutzerSchreibzeichen:=XDPersonalSchreibzeichen.AsString;
        BenutzerEmail:=XDPersonalEmail.AsString;
        BenutzerFarbe:=XDPersonalFarbe.AsInteger;
        BenutzerID:=XDPersonalPersonalGUID.AsString;
        BenutzerStundensatzIntern:=XDPersonalStundensatzIntern.AsFloat;
        RCWlist.text:=xdpersonalrechtecadiaweb.asstring;
        RCWleeren;
        RCWLISTtoRECORD;
        mylocalstorage:=Tlocalstorage.Create;
        mylocalstorage.SetValue('CadiaWEBBenutzer',BenutzerLoginName);
        if CheckPasswortMerken.checked then mylocalstorage.SetValue('BenutzerZugangSpeichern','1');
        if not CheckPasswortMerken.checked then mylocalstorage.SetValue('BenutzerZugangSpeichern','0');
        if CheckPasswortMerken.checked then
        begin
          mylocalstorage.SetValue('CadiaWEBPW',XorStr(BenutzerPasswort,25));
        end;

        if not CheckPasswortMerken.checked then
        begin
          mylocalstorage.SetValue('CadiaWEBPW','');
        end;
        if scannereinstellung='' then scannereinstellung:='11111111111';
        mylocalstorage.SetValue('CadiaWEBScanner',scannereinstellung);
        mylocalstorage.Free;
        lblchecklogin.Caption:='Anmeldung erfolgreich'+booltostr(rcw.kontakte);


        //(Kundennummer:string;AppKey:string;UserName:string;UserID:string;Absenderzeile:string;Versiondate:string):string;
        logbuchurl:='https://cadia-software.net/cadiaautoserver/xdata/InformationService/cwlogbuch?Kundennummer='+dm2.tableSYSDATCadiaKundennummer.AsString+'&AppKey='+CadiaAppKey+'&UserName='+BenutzerNachname;
        logbuchurl:=logbuchurl+'&UserID='+BenutzerID;
        //logbuchurl:=logbuchurl+'&Absenderzeile='+Leftstr(dm2.tableSYSDATAbsenderzeile.asstring,70);
        if textabsenderzeile='' then TextAbsenderzeile:='unbekannt';

        logbuchurl:=logbuchurl+'&Absenderzeile='+TextAbsenderzeile;
        logbuchurl:=logbuchurl+'&Versiondate='+Versionslabel3;
        logbuchurl:=logbuchurl+'&Versionnumber='+Versionslabel2;
        dm2.WebHttpRequestLogbuch.URL:=logbuchurl;

        dm2.WebHttpRequestLogbuch.Execute;
        KalkuliereMitteilungen;
      end
      else
      begin
        lblchecklogin.Caption:='Dieser Benutzer ist nicht zugelassen';
      end;
    end
    else
    begin
      lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';
    end;

  xdpersonal.Close;
  form1.SetControls;
end;


procedure TForm1.xdsMitteilungenAfterOpen(DataSet: TDataSet);
begin
  btnMitteilungen.Caption:='Mitteilungen ('+inttostr(xdsMitteilungen.RecordCount)+')';
  if xdsMitteilungen.RecordCount>0 then
  begin
    btnMitteilungen.ElementClassName:='btn btn-danger btn-sm text-center m-1';
  end
  else
  begin
    btnMitteilungen.ElementClassName:='btn btn-info btn-sm text-center m-1';
  end;
  xdsMitteilungen.Close;
end;

procedure TForm1.RCWLISTtoRECORD;
begin

  if RCWLIST.Values['Zugelassen']<>'' then RCW.Zugelassen:=strtobool(RCWLIST.Values['Zugelassen']) else RCW.Zugelassen:=TRUE;
  if RCWLIST.Values['Kontakte']<>'' then RCW.Kontakte:=strtobool(RCWLIST.Values['Kontakte']) else RCW.Kontakte:=TRUE;
  if RCWLIST.Values['Artikel']<>'' then RCW.Artikel:=strtobool(RCWLIST.Values['Artikel']) else RCW.Artikel:=TRUE;
  if RCWLIST.Values['OffeneAngebote']<>'' then RCW.OffeneAngebote:=strtobool(RCWLIST.Values['OffeneAngebote']) else RCW.OffeneAngebote:=TRUE;
  if RCWLIST.Values['OffeneAuftraege']<>'' then RCW.OffeneAuftraege:=strtobool(RCWLIST.Values['OffeneAuftraege']) else RCW.OffeneAuftraege:=TRUE;
  if RCWLIST.Values['OffeneLieferscheine']<>'' then RCW.OffeneLieferscheine:=strtobool(RCWLIST.Values['OffeneLieferscheine']) else RCW.OffeneLieferscheine:=TRUE;
  if RCWLIST.Values['Termine']<>'' then RCW.Termine:=strtobool(RCWLIST.Values['Termine']) else RCW.Termine:=TRUE;
  if RCWLIST.Values['NurPersTermine']<>'' then RCW.NurPersTermine:=strtobool(RCWLIST.Values['NurPersTermine']) else RCW.NurPersTermine:=FALSE;
  if RCWLIST.Values['Emails']<>'' then RCW.Emails:=strtobool(RCWLIST.Values['Emails']) else RCW.Emails:=TRUE;
  if RCWLIST.Values['BelegePositionen']<>'' then RCW.BelegePositionen:=strtobool(RCWLIST.Values['BelegePositionen']) else RCW.BelegePositionen:=TRUE;
  if RCWLIST.Values['Anrufe']<>'' then RCW.Anrufe:=strtobool(RCWLIST.Values['Anrufe']) else RCW.Anrufe:=TRUE;
  if RCWLIST.Values['Zeiterfassung']<>'' then RCW.Zeiterfassung:=strtobool(RCWLIST.Values['Zeiterfassung']) else RCW.Zeiterfassung:=TRUE;
  if RCWLIST.Values['Einkaufspreise']<>'' then RCW.Einkaufspreise:=strtobool(RCWLIST.Values['Einkaufspreise']) else RCW.Einkaufspreise:=TRUE;
  if RCWLIST.Values['Verkaufspreise']<>'' then RCW.Verkaufspreise:=strtobool(RCWLIST.Values['Verkaufspreise']) else RCW.Verkaufspreise:=TRUE;
  if RCWLIST.Values['Mitteilungen']<>'' then RCW.Mitteilungen:=strtobool(RCWLIST.Values['Mitteilungen']) else RCW.Mitteilungen:=TRUE;
  if RCWLIST.Values['Inventur']<>'' then RCW.Inventur:=strtobool(RCWLIST.Values['Inventur']) else RCW.Inventur:=TRUE;
end;

procedure TForm1.RCWleeren;
begin
  RCW.Zugelassen:=True;
  RCW.Kontakte:=True;
  RCW.Artikel:=True;
  RCW.OffeneAngebote:=True;
  RCW.OffeneAuftraege:=True;
  RCW.OffeneLieferscheine:=True;
  RCW.Termine:=True;
  RCW.NurPersTermine:=false;
  RCW.Emails:=True;
  RCW.BelegePositionen:=True;
  RCW.Anrufe:=True;
  RCW.Zeiterfassung:=True;
  RCW.Einkaufspreise:=True;
  RCW.Verkaufspreise:=True;
  RCW.Mitteilungen:=True;
  RCW.Inventur:=True;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblAnmeldung := TLabel.Create(Self);
  labelonlinestatus := TLabel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  panelAnmeldung := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lblchecklogin := TLabel.Create(Self);
  edtBenutzer := TEdit.Create(Self);
  edtPassword := TEdit.Create(Self);
  btnAnmelden := TButton.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  WebPanelMenue := TPanel.Create(Self);
  btnLogout := TButton.Create(Self);
  btnTermine := TButton.Create(Self);
  btnEmails := TButton.Create(Self);
  btnAnrufe := TButton.Create(Self);
  btnPZE := TButton.Create(Self);
  btnTelefonnummern := TButton.Create(Self);
  btnMitteilungen := TButton.Create(Self);
  btnTickets := TButton.Create(Self);
  btnBeenden := TButton.Create(Self);
  btnKontakte := TButton.Create(Self);
  btnArtikel := TButton.Create(Self);
  btnBestellvormerkung := TButton.Create(Self);
  btnAngebote := TButton.Create(Self);
  btnAuftrag := TButton.Create(Self);
  btnLieferscheine := TButton.Create(Self);
  btnBelegePositionen := TButton.Create(Self);
  btnInventur := TButton.Create(Self);
  btn14584 := TButton.Create(Self);
  Menue10055 := TPanel.Create(Self);
  btnLogbuch := TButton.Create(Self);
  btnZurueck := TButton.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  CheckPasswortMerken := TCheckBox.Create(Self);
  XDPersonal := TXDataWebDataSet.Create(Self);
  XDPersonalPersonalnummer := TIntegerField.Create(Self);
  XDPersonalNachname := TStringField.Create(Self);
  XDPersonalVorname := TStringField.Create(Self);
  XDPersonalSchreibzeichen := TStringField.Create(Self);
  XDPersonalLoginName := TStringField.Create(Self);
  XDPersonalPassword := TStringField.Create(Self);
  XDPersonalEnabled := TBooleanField.Create(Self);
  XDPersonalEmail := TStringField.Create(Self);
  XDPersonalFarbe := TIntegerField.Create(Self);
  XDPersonalPersonalGUID := TStringField.Create(Self);
  XDPersonalRechteCadiaWEB := TStringField.Create(Self);
  XDPersonalStundensatzIntern := TFloatField.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  AuthConnection := TXDataWebConnection.Create(Self);
  xdsMitteilungen := TXDataWebDataSet.Create(Self);
  xdsMitteilungenMSGBoardID := TXDataWebEntityField.Create(Self);
  xdsMitteilungenToPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungenMSGBoardSubID := TStringField.Create(Self);
  xdsMitteilungenToNachname := TStringField.Create(Self);
  xdsMitteilungenToVorname := TStringField.Create(Self);
  xdsMitteilungenDatumGelesen := TDateTimeField.Create(Self);
  xdsMitteilungenDatumErledigt := TDateTimeField.Create(Self);
  xdsMitteilungenMSGBoardIDFromPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungenMSGBoardIDID := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDDatum := TDateTimeField.Create(Self);
  xdsMitteilungenMSGBoardIDFromNachname := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDFromVorname := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDBetreff := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDNotiz := TStringField.Create(Self);
  xdsMitteilungenToPersonalnummerPersonalnummer := TIntegerField.Create(Self);
  xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer := TIntegerField.Create(Self);

  lblAnmeldung.BeforeLoadDFMValues;
  labelonlinestatus.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  panelAnmeldung.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lblchecklogin.BeforeLoadDFMValues;
  edtBenutzer.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  btnAnmelden.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  WebPanelMenue.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  btnTermine.BeforeLoadDFMValues;
  btnEmails.BeforeLoadDFMValues;
  btnAnrufe.BeforeLoadDFMValues;
  btnPZE.BeforeLoadDFMValues;
  btnTelefonnummern.BeforeLoadDFMValues;
  btnMitteilungen.BeforeLoadDFMValues;
  btnTickets.BeforeLoadDFMValues;
  btnBeenden.BeforeLoadDFMValues;
  btnKontakte.BeforeLoadDFMValues;
  btnArtikel.BeforeLoadDFMValues;
  btnBestellvormerkung.BeforeLoadDFMValues;
  btnAngebote.BeforeLoadDFMValues;
  btnAuftrag.BeforeLoadDFMValues;
  btnLieferscheine.BeforeLoadDFMValues;
  btnBelegePositionen.BeforeLoadDFMValues;
  btnInventur.BeforeLoadDFMValues;
  btn14584.BeforeLoadDFMValues;
  Menue10055.BeforeLoadDFMValues;
  btnLogbuch.BeforeLoadDFMValues;
  btnZurueck.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  CheckPasswortMerken.BeforeLoadDFMValues;
  XDPersonal.BeforeLoadDFMValues;
  XDPersonalPersonalnummer.BeforeLoadDFMValues;
  XDPersonalNachname.BeforeLoadDFMValues;
  XDPersonalVorname.BeforeLoadDFMValues;
  XDPersonalSchreibzeichen.BeforeLoadDFMValues;
  XDPersonalLoginName.BeforeLoadDFMValues;
  XDPersonalPassword.BeforeLoadDFMValues;
  XDPersonalEnabled.BeforeLoadDFMValues;
  XDPersonalEmail.BeforeLoadDFMValues;
  XDPersonalFarbe.BeforeLoadDFMValues;
  XDPersonalPersonalGUID.BeforeLoadDFMValues;
  XDPersonalRechteCadiaWEB.BeforeLoadDFMValues;
  XDPersonalStundensatzIntern.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  AuthConnection.BeforeLoadDFMValues;
  xdsMitteilungen.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardID.BeforeLoadDFMValues;
  xdsMitteilungenToPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardSubID.BeforeLoadDFMValues;
  xdsMitteilungenToNachname.BeforeLoadDFMValues;
  xdsMitteilungenToVorname.BeforeLoadDFMValues;
  xdsMitteilungenDatumGelesen.BeforeLoadDFMValues;
  xdsMitteilungenDatumErledigt.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDID.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDDatum.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromNachname.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromVorname.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDBetreff.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDNotiz.BeforeLoadDFMValues;
  xdsMitteilungenToPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 637;
    Height := 585;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnBeforeUnload', 'WebFormBeforeUnload');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblAnmeldung.SetParentComponent(Self);
    lblAnmeldung.Name := 'lblAnmeldung';
    lblAnmeldung.Left := -2;
    lblAnmeldung.Top := 406;
    lblAnmeldung.Width := 76;
    lblAnmeldung.Height := 15;
    lblAnmeldung.Margins.Top := 0;
    lblAnmeldung.Margins.Bottom := 0;
    lblAnmeldung.Caption := 'lblAnmeldung';
    lblAnmeldung.ElementClassName := 'h6 m-2';
    lblAnmeldung.ElementFont := efCSS;
    lblAnmeldung.ElementPosition := epIgnore;
    lblAnmeldung.HeightPercent := 100.000000000000000000;
    lblAnmeldung.WidthPercent := 100.000000000000000000;
    labelonlinestatus.SetParentComponent(Self);
    labelonlinestatus.Name := 'labelonlinestatus';
    labelonlinestatus.Left := 0;
    labelonlinestatus.Top := 424;
    labelonlinestatus.Width := 89;
    labelonlinestatus.Height := 15;
    labelonlinestatus.Caption := 'labelonlinestatus';
    labelonlinestatus.ElementClassName := 'h6 small m-2';
    labelonlinestatus.ElementFont := efCSS;
    labelonlinestatus.HeightPercent := 100.000000000000000000;
    labelonlinestatus.WidthPercent := 100.000000000000000000;
    WebDBLabel1.SetParentComponent(Self);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 0;
    WebDBLabel1.Top := 445;
    WebDBLabel1.Width := 73;
    WebDBLabel1.Height := 15;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.ElementClassName := 'h6 small m-2';
    WebDBLabel1.ElementFont := efCSS;
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'CadiaKundennummer';
    WebDBLabel1.DataSource := DM2.sourceSysdat;
    panelAnmeldung.SetParentComponent(Self);
    panelAnmeldung.Name := 'panelAnmeldung';
    panelAnmeldung.Left := 56;
    panelAnmeldung.Top := 94;
    panelAnmeldung.Width := 300;
    panelAnmeldung.Height := 309;
    panelAnmeldung.ElementClassName := 'card m-1 border-info';
    panelAnmeldung.Caption := 'panelAnmeldung';
    panelAnmeldung.Color := 8340248;
    panelAnmeldung.ElementFont := efCSS;
    panelAnmeldung.ElementPosition := epIgnore;
    panelAnmeldung.ShowCaption := False;
    panelAnmeldung.TabOrder := 0;
    WebLabel3.SetParentComponent(panelAnmeldung);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 24;
    WebLabel3.Top := 13;
    WebLabel3.Width := 63;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Anmeldung';
    WebLabel3.ElementClassName := 'h3 text-info m-1';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.ElementPosition := epIgnore;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lblchecklogin.SetParentComponent(panelAnmeldung);
    lblchecklogin.Name := 'lblchecklogin';
    lblchecklogin.Left := 3;
    lblchecklogin.Top := 227;
    lblchecklogin.Width := 71;
    lblchecklogin.Height := 15;
    lblchecklogin.Caption := 'lblchecklogin';
    lblchecklogin.ChildOrder := 6;
    lblchecklogin.ElementClassName := 'h6 text-danger';
    lblchecklogin.ElementFont := efCSS;
    lblchecklogin.HeightStyle := ssAuto;
    lblchecklogin.HeightPercent := 100.000000000000000000;
    lblchecklogin.WordWrap := True;
    lblchecklogin.WidthStyle := ssAuto;
    lblchecklogin.WidthPercent := 100.000000000000000000;
    edtBenutzer.SetParentComponent(panelAnmeldung);
    edtBenutzer.Name := 'edtBenutzer';
    edtBenutzer.Left := 24;
    edtBenutzer.Top := 54;
    edtBenutzer.Width := 153;
    edtBenutzer.Height := 25;
    edtBenutzer.ChildOrder := 1;
    edtBenutzer.ElementClassName := 'form-control m-1';
    edtBenutzer.ElementFont := efCSS;
    edtBenutzer.ElementPosition := epIgnore;
    edtBenutzer.HeightStyle := ssAuto;
    edtBenutzer.HeightPercent := 100.000000000000000000;
    edtBenutzer.TextHint := 'Benutzername';
    edtBenutzer.WidthPercent := 100.000000000000000000;
    SetEvent(edtBenutzer, Self, 'OnKeyPress', 'edtBenutzerKeyPress');
    edtPassword.SetParentComponent(panelAnmeldung);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 24;
    edtPassword.Top := 105;
    edtPassword.Width := 153;
    edtPassword.Height := 25;
    edtPassword.ChildOrder := 2;
    edtPassword.ElementClassName := 'form-control m-1';
    edtPassword.ElementFont := efCSS;
    edtPassword.ElementPosition := epIgnore;
    edtPassword.HeightStyle := ssAuto;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.PasswordChar := '*';
    edtPassword.TabOrder := 1;
    edtPassword.TextHint := 'Passwort';
    edtPassword.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword, Self, 'OnKeyPress', 'edtPasswordKeyPress');
    btnAnmelden.SetParentComponent(panelAnmeldung);
    btnAnmelden.Name := 'btnAnmelden';
    btnAnmelden.Left := 81;
    btnAnmelden.Top := 164;
    btnAnmelden.Width := 96;
    btnAnmelden.Height := 41;
    btnAnmelden.Caption := 'Anmelden';
    btnAnmelden.ChildOrder := 5;
    btnAnmelden.ElementClassName := 'btn btn-info m-1 text-left';
    btnAnmelden.ElementFont := efCSS;
    btnAnmelden.ElementPosition := epIgnore;
    btnAnmelden.HeightStyle := ssAuto;
    btnAnmelden.HeightPercent := 100.000000000000000000;
    btnAnmelden.TabOrder := 2;
    btnAnmelden.WidthStyle := ssAuto;
    btnAnmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnAnmelden, Self, 'OnClick', 'btnAnmeldenClick');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 1;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'col d-flex justify-content-center';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    WebPanelMenue.SetParentComponent(Self);
    WebPanelMenue.Name := 'WebPanelMenue';
    WebPanelMenue.Left := 272;
    WebPanelMenue.Top := 107;
    WebPanelMenue.Width := 400;
    WebPanelMenue.Height := 375;
    WebPanelMenue.ElementClassName := 'card m-1 border-info';
    WebPanelMenue.Caption := 'WebPanelMenue';
    WebPanelMenue.Color := 8340248;
    WebPanelMenue.ElementFont := efCSS;
    WebPanelMenue.ShowCaption := False;
    WebPanelMenue.TabOrder := 3;
    btnLogout.SetParentComponent(WebPanelMenue);
    btnLogout.Name := 'btnLogout';
    btnLogout.Left := 203;
    btnLogout.Top := 287;
    btnLogout.Width := 180;
    btnLogout.Height := 30;
    btnLogout.Caption := 'Abmelden';
    btnLogout.ChildOrder := 7;
    btnLogout.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnLogout.ElementFont := efCSS;
    btnLogout.HeightStyle := ssAuto;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    btnTermine.SetParentComponent(WebPanelMenue);
    btnTermine.Name := 'btnTermine';
    btnTermine.Left := 203;
    btnTermine.Top := 8;
    btnTermine.Width := 180;
    btnTermine.Height := 30;
    btnTermine.Caption := 'Termine';
    btnTermine.ChildOrder := 11;
    btnTermine.ElementClassName := 'btn btn-info btn-sm text-sm text-center m-1';
    btnTermine.ElementFont := efCSS;
    btnTermine.HeightStyle := ssAuto;
    btnTermine.HeightPercent := 100.000000000000000000;
    btnTermine.WidthPercent := 100.000000000000000000;
    SetEvent(btnTermine, Self, 'OnClick', 'btnTermineClick');
    btnEmails.SetParentComponent(WebPanelMenue);
    btnEmails.Name := 'btnEmails';
    btnEmails.Left := 203;
    btnEmails.Top := 48;
    btnEmails.Width := 180;
    btnEmails.Height := 30;
    btnEmails.Caption := 'Emails';
    btnEmails.ChildOrder := 11;
    btnEmails.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnEmails.ElementFont := efCSS;
    btnEmails.HeightStyle := ssAuto;
    btnEmails.HeightPercent := 100.000000000000000000;
    btnEmails.WidthPercent := 100.000000000000000000;
    SetEvent(btnEmails, Self, 'OnClick', 'btnEmailsClick');
    btnAnrufe.SetParentComponent(WebPanelMenue);
    btnAnrufe.Name := 'btnAnrufe';
    btnAnrufe.Left := 203;
    btnAnrufe.Top := 88;
    btnAnrufe.Width := 180;
    btnAnrufe.Height := 30;
    btnAnrufe.Caption := 'Anrufe';
    btnAnrufe.ChildOrder := 11;
    btnAnrufe.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAnrufe.ElementFont := efCSS;
    btnAnrufe.HeightStyle := ssAuto;
    btnAnrufe.HeightPercent := 100.000000000000000000;
    btnAnrufe.WidthPercent := 100.000000000000000000;
    SetEvent(btnAnrufe, Self, 'OnClick', 'btnAnrufeClick');
    btnPZE.SetParentComponent(WebPanelMenue);
    btnPZE.Name := 'btnPZE';
    btnPZE.Left := 203;
    btnPZE.Top := 127;
    btnPZE.Width := 180;
    btnPZE.Height := 30;
    btnPZE.Caption := 'Zeiterfassung (PZE)';
    btnPZE.ChildOrder := 11;
    btnPZE.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnPZE.ElementFont := efCSS;
    btnPZE.HeightStyle := ssAuto;
    btnPZE.HeightPercent := 100.000000000000000000;
    btnPZE.WidthPercent := 100.000000000000000000;
    SetEvent(btnPZE, Self, 'OnClick', 'btnPZEClick');
    btnTelefonnummern.SetParentComponent(WebPanelMenue);
    btnTelefonnummern.Name := 'btnTelefonnummern';
    btnTelefonnummern.Left := 203;
    btnTelefonnummern.Top := 167;
    btnTelefonnummern.Width := 180;
    btnTelefonnummern.Height := 30;
    btnTelefonnummern.Caption := 'Telefonnummern';
    btnTelefonnummern.ChildOrder := 11;
    btnTelefonnummern.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnTelefonnummern.ElementFont := efCSS;
    btnTelefonnummern.HeightStyle := ssAuto;
    btnTelefonnummern.HeightPercent := 100.000000000000000000;
    btnTelefonnummern.WidthPercent := 100.000000000000000000;
    SetEvent(btnTelefonnummern, Self, 'OnClick', 'btnTelefonnummernClick');
    btnMitteilungen.SetParentComponent(WebPanelMenue);
    btnMitteilungen.Name := 'btnMitteilungen';
    btnMitteilungen.Left := 203;
    btnMitteilungen.Top := 207;
    btnMitteilungen.Width := 180;
    btnMitteilungen.Height := 30;
    btnMitteilungen.Caption := 'Mitteilungen';
    btnMitteilungen.ChildOrder := 11;
    btnMitteilungen.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnMitteilungen.ElementFont := efCSS;
    btnMitteilungen.HeightStyle := ssAuto;
    btnMitteilungen.HeightPercent := 100.000000000000000000;
    btnMitteilungen.WidthPercent := 100.000000000000000000;
    SetEvent(btnMitteilungen, Self, 'OnClick', 'btnMitteilungenClick');
    btnTickets.SetParentComponent(WebPanelMenue);
    btnTickets.Name := 'btnTickets';
    btnTickets.Left := 203;
    btnTickets.Top := 247;
    btnTickets.Width := 180;
    btnTickets.Height := 30;
    btnTickets.Caption := 'Tickets';
    btnTickets.ChildOrder := 11;
    btnTickets.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnTickets.ElementFont := efCSS;
    btnTickets.HeightStyle := ssAuto;
    btnTickets.HeightPercent := 100.000000000000000000;
    btnTickets.WidthPercent := 100.000000000000000000;
    SetEvent(btnTickets, Self, 'OnClick', 'btnTicketsClick');
    btnBeenden.SetParentComponent(WebPanelMenue);
    btnBeenden.Name := 'btnBeenden';
    btnBeenden.Left := 203;
    btnBeenden.Top := 327;
    btnBeenden.Width := 180;
    btnBeenden.Height := 30;
    btnBeenden.Caption := 'Schliessen';
    btnBeenden.ChildOrder := 7;
    btnBeenden.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnBeenden.ElementFont := efCSS;
    btnBeenden.HeightStyle := ssAuto;
    btnBeenden.HeightPercent := 100.000000000000000000;
    btnBeenden.WidthPercent := 100.000000000000000000;
    SetEvent(btnBeenden, Self, 'OnClick', 'btnBeendenClick');
    btnKontakte.SetParentComponent(WebPanelMenue);
    btnKontakte.Name := 'btnKontakte';
    btnKontakte.Left := 3;
    btnKontakte.Top := 8;
    btnKontakte.Width := 180;
    btnKontakte.Height := 30;
    btnKontakte.Caption := 'Kontakte';
    btnKontakte.ChildOrder := 11;
    btnKontakte.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnKontakte.ElementFont := efCSS;
    btnKontakte.HeightStyle := ssAuto;
    btnKontakte.HeightPercent := 100.000000000000000000;
    btnKontakte.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontakte, Self, 'OnClick', 'btnKontakteClick');
    btnArtikel.SetParentComponent(WebPanelMenue);
    btnArtikel.Name := 'btnArtikel';
    btnArtikel.Left := 3;
    btnArtikel.Top := 48;
    btnArtikel.Width := 180;
    btnArtikel.Height := 30;
    btnArtikel.Caption := 'Artikel';
    btnArtikel.ChildOrder := 11;
    btnArtikel.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnArtikel.ElementFont := efCSS;
    btnArtikel.HeightStyle := ssAuto;
    btnArtikel.HeightPercent := 100.000000000000000000;
    btnArtikel.WidthPercent := 100.000000000000000000;
    SetEvent(btnArtikel, Self, 'OnClick', 'btnArtikelClick');
    btnBestellvormerkung.SetParentComponent(WebPanelMenue);
    btnBestellvormerkung.Name := 'btnBestellvormerkung';
    btnBestellvormerkung.Left := 3;
    btnBestellvormerkung.Top := 88;
    btnBestellvormerkung.Width := 180;
    btnBestellvormerkung.Height := 30;
    btnBestellvormerkung.Caption := 'Bestellvormerkung';
    btnBestellvormerkung.ChildOrder := 11;
    btnBestellvormerkung.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnBestellvormerkung.ElementFont := efCSS;
    btnBestellvormerkung.HeightStyle := ssAuto;
    btnBestellvormerkung.HeightPercent := 100.000000000000000000;
    btnBestellvormerkung.WidthPercent := 100.000000000000000000;
    SetEvent(btnBestellvormerkung, Self, 'OnClick', 'btnBestellvormerkungClick');
    btnAngebote.SetParentComponent(WebPanelMenue);
    btnAngebote.Name := 'btnAngebote';
    btnAngebote.Left := 3;
    btnAngebote.Top := 127;
    btnAngebote.Width := 180;
    btnAngebote.Height := 30;
    btnAngebote.Caption := 'Angebote (offen)';
    btnAngebote.ChildOrder := 11;
    btnAngebote.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAngebote.ElementFont := efCSS;
    btnAngebote.HeightStyle := ssAuto;
    btnAngebote.HeightPercent := 100.000000000000000000;
    btnAngebote.WidthPercent := 100.000000000000000000;
    SetEvent(btnAngebote, Self, 'OnClick', 'btnAngeboteClick');
    btnAuftrag.SetParentComponent(WebPanelMenue);
    btnAuftrag.Name := 'btnAuftrag';
    btnAuftrag.Left := 3;
    btnAuftrag.Top := 167;
    btnAuftrag.Width := 180;
    btnAuftrag.Height := 30;
    btnAuftrag.Caption := 'Auftr'#228'ge (offen)';
    btnAuftrag.ChildOrder := 11;
    btnAuftrag.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAuftrag.ElementFont := efCSS;
    btnAuftrag.HeightStyle := ssAuto;
    btnAuftrag.HeightPercent := 100.000000000000000000;
    btnAuftrag.WidthPercent := 100.000000000000000000;
    SetEvent(btnAuftrag, Self, 'OnClick', 'btnAuftragClick');
    btnLieferscheine.SetParentComponent(WebPanelMenue);
    btnLieferscheine.Name := 'btnLieferscheine';
    btnLieferscheine.Left := 3;
    btnLieferscheine.Top := 207;
    btnLieferscheine.Width := 180;
    btnLieferscheine.Height := 30;
    btnLieferscheine.Caption := 'Lieferscheine (offen)';
    btnLieferscheine.ChildOrder := 11;
    btnLieferscheine.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnLieferscheine.ElementFont := efCSS;
    btnLieferscheine.HeightStyle := ssAuto;
    btnLieferscheine.HeightPercent := 100.000000000000000000;
    btnLieferscheine.WidthPercent := 100.000000000000000000;
    SetEvent(btnLieferscheine, Self, 'OnClick', 'btnLieferscheineClick');
    btnBelegePositionen.SetParentComponent(WebPanelMenue);
    btnBelegePositionen.Name := 'btnBelegePositionen';
    btnBelegePositionen.Left := 3;
    btnBelegePositionen.Top := 247;
    btnBelegePositionen.Width := 180;
    btnBelegePositionen.Height := 30;
    btnBelegePositionen.Caption := 'Belege / Positionen';
    btnBelegePositionen.ChildOrder := 11;
    btnBelegePositionen.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnBelegePositionen.ElementFont := efCSS;
    btnBelegePositionen.HeightStyle := ssAuto;
    btnBelegePositionen.HeightPercent := 100.000000000000000000;
    btnBelegePositionen.WidthPercent := 100.000000000000000000;
    SetEvent(btnBelegePositionen, Self, 'OnClick', 'btnBelegePositionenClick');
    btnInventur.SetParentComponent(WebPanelMenue);
    btnInventur.Name := 'btnInventur';
    btnInventur.Left := 3;
    btnInventur.Top := 287;
    btnInventur.Width := 180;
    btnInventur.Height := 30;
    btnInventur.Caption := 'Inventur';
    btnInventur.ChildOrder := 11;
    btnInventur.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnInventur.ElementFont := efCSS;
    btnInventur.HeightStyle := ssAuto;
    btnInventur.HeightPercent := 100.000000000000000000;
    btnInventur.WidthPercent := 100.000000000000000000;
    SetEvent(btnInventur, Self, 'OnClick', 'btnInventurClick');
    btn14584.SetParentComponent(WebPanelMenue);
    btn14584.Name := 'btn14584';
    btn14584.Left := 3;
    btn14584.Top := 327;
    btn14584.Width := 180;
    btn14584.Height := 30;
    btn14584.Caption := '14584';
    btn14584.ChildOrder := 7;
    btn14584.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btn14584.ElementFont := efCSS;
    btn14584.HeightStyle := ssAuto;
    btn14584.HeightPercent := 100.000000000000000000;
    btn14584.WidthPercent := 100.000000000000000000;
    SetEvent(btn14584, Self, 'OnClick', 'btn14584Click');
    Menue10055.SetParentComponent(Self);
    Menue10055.Name := 'Menue10055';
    Menue10055.Left := 376;
    Menue10055.Top := 35;
    Menue10055.Width := 304;
    Menue10055.Height := 329;
    Menue10055.ElementClassName := 'card m-1 border-info';
    Menue10055.Caption := 'WebPanelMenue';
    Menue10055.ChildOrder := 7;
    Menue10055.Color := 8340248;
    Menue10055.ElementBodyClassName := 'card-body';
    Menue10055.ElementFont := efCSS;
    Menue10055.ShowCaption := False;
    Menue10055.TabOrder := 4;
    Menue10055.Visible := False;
    btnLogbuch.SetParentComponent(Menue10055);
    btnLogbuch.Name := 'btnLogbuch';
    btnLogbuch.Left := 3;
    btnLogbuch.Top := 8;
    btnLogbuch.Width := 145;
    btnLogbuch.Height := 25;
    btnLogbuch.Caption := 'Logbuch';
    btnLogbuch.ChildOrder := 11;
    btnLogbuch.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnLogbuch.ElementFont := efCSS;
    btnLogbuch.HeightStyle := ssAuto;
    btnLogbuch.HeightPercent := 100.000000000000000000;
    btnLogbuch.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogbuch, Self, 'OnClick', 'btnLogbuchClick');
    btnZurueck.SetParentComponent(Menue10055);
    btnZurueck.Name := 'btnZurueck';
    btnZurueck.Left := 154;
    btnZurueck.Top := 290;
    btnZurueck.Width := 145;
    btnZurueck.Height := 25;
    btnZurueck.Caption := 'Hauptmenue';
    btnZurueck.ChildOrder := 7;
    btnZurueck.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnZurueck.ElementFont := efCSS;
    btnZurueck.HeightStyle := ssAuto;
    btnZurueck.HeightPercent := 100.000000000000000000;
    btnZurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnZurueck, Self, 'OnClick', 'btnZurueckClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 133;
    Container3.Top := 508;
    Container3.Width := 100;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1 border border-infor';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssPercent;
    Container3.WidthPercent := 80.000000000000000000;
    Container3.ChildOrder := 8;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    Container3.ScrollStyle := ssNone;
    CheckPasswortMerken.SetParentComponent(Self);
    CheckPasswortMerken.Name := 'CheckPasswortMerken';
    CheckPasswortMerken.AlignWithMargins := True;
    CheckPasswortMerken.Left := 8;
    CheckPasswortMerken.Top := 555;
    CheckPasswortMerken.Width := 348;
    CheckPasswortMerken.Height := 22;
    CheckPasswortMerken.Caption := 'Passwort merken';
    CheckPasswortMerken.ChildOrder := 5;
    CheckPasswortMerken.ElementClassName := 'form-check checkbox no-border';
    CheckPasswortMerken.ElementButtonClassName := 'form-check-input no-border';
    CheckPasswortMerken.ElementLabelClassName := 'form-check-label';
    CheckPasswortMerken.ElementFont := efCSS;
    CheckPasswortMerken.ElementPosition := epIgnore;
    CheckPasswortMerken.HeightStyle := ssAuto;
    CheckPasswortMerken.HeightPercent := 100.000000000000000000;
    CheckPasswortMerken.WidthStyle := ssAuto;
    CheckPasswortMerken.WidthPercent := 100.000000000000000000;
    XDPersonal.SetParentComponent(Self);
    XDPersonal.Name := 'XDPersonal';
    XDPersonal.AfterOpen := XDPersonalAfterOpen;
    XDPersonal.EntitySetName := 'Personal';
    XDPersonal.Connection := DM2.XDataWebConnection1;
    XDPersonal.Left := 11;
    XDPersonal.Top := 91;
    XDPersonalPersonalnummer.SetParentComponent(XDPersonal);
    XDPersonalPersonalnummer.Name := 'XDPersonalPersonalnummer';
    XDPersonalPersonalnummer.FieldName := 'Personalnummer';
    XDPersonalPersonalnummer.Required := True;
    XDPersonalNachname.SetParentComponent(XDPersonal);
    XDPersonalNachname.Name := 'XDPersonalNachname';
    XDPersonalNachname.FieldName := 'Nachname';
    XDPersonalNachname.Size := 40;
    XDPersonalVorname.SetParentComponent(XDPersonal);
    XDPersonalVorname.Name := 'XDPersonalVorname';
    XDPersonalVorname.FieldName := 'Vorname';
    XDPersonalVorname.Size := 40;
    XDPersonalSchreibzeichen.SetParentComponent(XDPersonal);
    XDPersonalSchreibzeichen.Name := 'XDPersonalSchreibzeichen';
    XDPersonalSchreibzeichen.FieldName := 'Schreibzeichen';
    XDPersonalSchreibzeichen.Size := 10;
    XDPersonalLoginName.SetParentComponent(XDPersonal);
    XDPersonalLoginName.Name := 'XDPersonalLoginName';
    XDPersonalLoginName.FieldName := 'LoginName';
    XDPersonalLoginName.Size := 50;
    XDPersonalPassword.SetParentComponent(XDPersonal);
    XDPersonalPassword.Name := 'XDPersonalPassword';
    XDPersonalPassword.FieldName := 'Password';
    XDPersonalPassword.Size := 50;
    XDPersonalEnabled.SetParentComponent(XDPersonal);
    XDPersonalEnabled.Name := 'XDPersonalEnabled';
    XDPersonalEnabled.FieldName := 'Enabled';
    XDPersonalEmail.SetParentComponent(XDPersonal);
    XDPersonalEmail.Name := 'XDPersonalEmail';
    XDPersonalEmail.FieldName := 'Email';
    XDPersonalEmail.Size := 50;
    XDPersonalFarbe.SetParentComponent(XDPersonal);
    XDPersonalFarbe.Name := 'XDPersonalFarbe';
    XDPersonalFarbe.FieldName := 'Farbe';
    XDPersonalPersonalGUID.SetParentComponent(XDPersonal);
    XDPersonalPersonalGUID.Name := 'XDPersonalPersonalGUID';
    XDPersonalPersonalGUID.FieldName := 'PersonalGUID';
    XDPersonalPersonalGUID.Size := 38;
    XDPersonalRechteCadiaWEB.SetParentComponent(XDPersonal);
    XDPersonalRechteCadiaWEB.Name := 'XDPersonalRechteCadiaWEB';
    XDPersonalRechteCadiaWEB.FieldName := 'RechteCadiaWEB';
    XDPersonalRechteCadiaWEB.Size := 255;
    XDPersonalStundensatzIntern.SetParentComponent(XDPersonal);
    XDPersonalStundensatzIntern.Name := 'XDPersonalStundensatzIntern';
    XDPersonalStundensatzIntern.FieldName := 'StundensatzIntern';
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.URL := './config/CadiaWebConfig.cnf';
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 8;
    WebHttpRequest1.Top := 144;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := AuthConnection;
    WClient.Left := 8;
    WClient.Top := 240;
    AuthConnection.SetParentComponent(Self);
    AuthConnection.Name := 'AuthConnection';
    AuthConnection.URL := 'https://langwald-edv.net/cadiaserverauth';
    SetEvent(AuthConnection, Self, 'OnConnect', 'AuthConnectionConnect');
    AuthConnection.Left := 8;
    AuthConnection.Top := 192;
    xdsMitteilungen.SetParentComponent(Self);
    xdsMitteilungen.Name := 'xdsMitteilungen';
    xdsMitteilungen.AfterOpen := xdsMitteilungenAfterOpen;
    xdsMitteilungen.EntitySetName := 'MSGBoardSub';
    xdsMitteilungen.Connection := DM2.XDataWebConnection1;
    xdsMitteilungen.SubpropsDepth := 2;
    xdsMitteilungen.QueryString := '$expand=MSGBoardID, PersonalnummerTo';
    xdsMitteilungen.QueryTop := 100;
    xdsMitteilungen.Left := 242;
    xdsMitteilungen.Top := 13;
    xdsMitteilungenMSGBoardID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardID.Name := 'xdsMitteilungenMSGBoardID';
    xdsMitteilungenMSGBoardID.FieldName := 'MSGBoardID';
    xdsMitteilungenToPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToPersonalnummer.Name := 'xdsMitteilungenToPersonalnummer';
    xdsMitteilungenToPersonalnummer.FieldName := 'ToPersonalnummer';
    xdsMitteilungenMSGBoardSubID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardSubID.Name := 'xdsMitteilungenMSGBoardSubID';
    xdsMitteilungenMSGBoardSubID.FieldName := 'MSGBoardSubID';
    xdsMitteilungenMSGBoardSubID.Required := True;
    xdsMitteilungenMSGBoardSubID.Size := 38;
    xdsMitteilungenToNachname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToNachname.Name := 'xdsMitteilungenToNachname';
    xdsMitteilungenToNachname.FieldName := 'ToNachname';
    xdsMitteilungenToNachname.Size := 40;
    xdsMitteilungenToVorname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToVorname.Name := 'xdsMitteilungenToVorname';
    xdsMitteilungenToVorname.FieldName := 'ToVorname';
    xdsMitteilungenToVorname.Size := 40;
    xdsMitteilungenDatumGelesen.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenDatumGelesen.Name := 'xdsMitteilungenDatumGelesen';
    xdsMitteilungenDatumGelesen.FieldName := 'DatumGelesen';
    xdsMitteilungenDatumErledigt.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenDatumErledigt.Name := 'xdsMitteilungenDatumErledigt';
    xdsMitteilungenDatumErledigt.FieldName := 'DatumErledigt';
    xdsMitteilungenMSGBoardIDFromPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromPersonalnummer.Name := 'xdsMitteilungenMSGBoardIDFromPersonalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer';
    xdsMitteilungenMSGBoardIDID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDID.Name := 'xdsMitteilungenMSGBoardIDID';
    xdsMitteilungenMSGBoardIDID.FieldName := 'MSGBoardID.ID';
    xdsMitteilungenMSGBoardIDID.Size := 38;
    xdsMitteilungenMSGBoardIDDatum.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDDatum.Name := 'xdsMitteilungenMSGBoardIDDatum';
    xdsMitteilungenMSGBoardIDDatum.FieldName := 'MSGBoardID.Datum';
    xdsMitteilungenMSGBoardIDFromNachname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromNachname.Name := 'xdsMitteilungenMSGBoardIDFromNachname';
    xdsMitteilungenMSGBoardIDFromNachname.FieldName := 'MSGBoardID.FromNachname';
    xdsMitteilungenMSGBoardIDFromNachname.Size := 40;
    xdsMitteilungenMSGBoardIDFromVorname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromVorname.Name := 'xdsMitteilungenMSGBoardIDFromVorname';
    xdsMitteilungenMSGBoardIDFromVorname.FieldName := 'MSGBoardID.FromVorname';
    xdsMitteilungenMSGBoardIDFromVorname.Size := 40;
    xdsMitteilungenMSGBoardIDBetreff.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDBetreff.Name := 'xdsMitteilungenMSGBoardIDBetreff';
    xdsMitteilungenMSGBoardIDBetreff.FieldName := 'MSGBoardID.Betreff';
    xdsMitteilungenMSGBoardIDBetreff.Size := 255;
    xdsMitteilungenMSGBoardIDNotiz.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDNotiz.Name := 'xdsMitteilungenMSGBoardIDNotiz';
    xdsMitteilungenMSGBoardIDNotiz.FieldName := 'MSGBoardID.Notiz';
    xdsMitteilungenMSGBoardIDNotiz.Size := 255;
    xdsMitteilungenToPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToPersonalnummerPersonalnummer.Name := 'xdsMitteilungenToPersonalnummerPersonalnummer';
    xdsMitteilungenToPersonalnummerPersonalnummer.FieldName := 'ToPersonalnummer.Personalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.Name := 'xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer.Personalnummer';
  finally
    lblAnmeldung.AfterLoadDFMValues;
    labelonlinestatus.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    panelAnmeldung.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lblchecklogin.AfterLoadDFMValues;
    edtBenutzer.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    btnAnmelden.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    WebPanelMenue.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    btnTermine.AfterLoadDFMValues;
    btnEmails.AfterLoadDFMValues;
    btnAnrufe.AfterLoadDFMValues;
    btnPZE.AfterLoadDFMValues;
    btnTelefonnummern.AfterLoadDFMValues;
    btnMitteilungen.AfterLoadDFMValues;
    btnTickets.AfterLoadDFMValues;
    btnBeenden.AfterLoadDFMValues;
    btnKontakte.AfterLoadDFMValues;
    btnArtikel.AfterLoadDFMValues;
    btnBestellvormerkung.AfterLoadDFMValues;
    btnAngebote.AfterLoadDFMValues;
    btnAuftrag.AfterLoadDFMValues;
    btnLieferscheine.AfterLoadDFMValues;
    btnBelegePositionen.AfterLoadDFMValues;
    btnInventur.AfterLoadDFMValues;
    btn14584.AfterLoadDFMValues;
    Menue10055.AfterLoadDFMValues;
    btnLogbuch.AfterLoadDFMValues;
    btnZurueck.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    CheckPasswortMerken.AfterLoadDFMValues;
    XDPersonal.AfterLoadDFMValues;
    XDPersonalPersonalnummer.AfterLoadDFMValues;
    XDPersonalNachname.AfterLoadDFMValues;
    XDPersonalVorname.AfterLoadDFMValues;
    XDPersonalSchreibzeichen.AfterLoadDFMValues;
    XDPersonalLoginName.AfterLoadDFMValues;
    XDPersonalPassword.AfterLoadDFMValues;
    XDPersonalEnabled.AfterLoadDFMValues;
    XDPersonalEmail.AfterLoadDFMValues;
    XDPersonalFarbe.AfterLoadDFMValues;
    XDPersonalPersonalGUID.AfterLoadDFMValues;
    XDPersonalRechteCadiaWEB.AfterLoadDFMValues;
    XDPersonalStundensatzIntern.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    AuthConnection.AfterLoadDFMValues;
    xdsMitteilungen.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardID.AfterLoadDFMValues;
    xdsMitteilungenToPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardSubID.AfterLoadDFMValues;
    xdsMitteilungenToNachname.AfterLoadDFMValues;
    xdsMitteilungenToVorname.AfterLoadDFMValues;
    xdsMitteilungenDatumGelesen.AfterLoadDFMValues;
    xdsMitteilungenDatumErledigt.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDID.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDDatum.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromNachname.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromVorname.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDBetreff.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDNotiz.AfterLoadDFMValues;
    xdsMitteilungenToPersonalnummerPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.AfterLoadDFMValues;
  end;
end;

end.
